// extracted by mini-css-extract-plugin
module.exports = {"popupForm":"PopupForm_popupForm__4FN4x","btnSubmit":"PopupForm_btnSubmit__2A70z"};